import { PathPreserveQueryLocationStrategy } from './../custom/preserve-query-params';
import { WebsocketActions } from './../redux/wstomp/websocket-actions';
import { LoginGuard } from './pages/auth/check-login.guard';
import { PlayerService } from './../providers/player-service/player-service';
import { Injectable, NgModule } from '@angular/core';
import { BrowserModule, HAMMER_GESTURE_CONFIG, HammerGestureConfig } from '@angular/platform-browser';
import { RouteReuseStrategy } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy, NavParams } from '@ionic/angular';
import { IonicStorageModule } from '@ionic/storage-angular';
import { AppRoutingModule } from './app-routing.module';
import { MyApp } from './app.component';
import { HttpModule } from '@angular/http';
import { RecaptchaModule, RECAPTCHA_SETTINGS, RecaptchaSettings } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha';
import { ClubFlightService } from 'src/providers/club-flight-service/club-flight-service';
import { RemoteHttpService } from 'src/remote-http';
import { AuthenticationService } from 'src/authentication-service';
import { Preference } from 'src/storage/preference';
import { MyGolfStorageService } from 'src/storage/mygolf-storage.service';
import { VolatileStorage } from 'src/storage/volatile-storage';
import { SessionActions, SessionDataService, SessionEffects } from 'src/redux/session';
import { combineReducers, compose, StoreModule } from '@ngrx/store';
import { DeviceService } from 'src/providers/device-service/device-service';
import { DeviceActionEffects, DeviceDataService } from 'src/redux/device';
import { ConnectionService } from 'src/providers/connection-service/connection-service';
import { BatteryStatus } from '@ionic-native/battery-status/ngx';
import { AppVersion } from '@ionic-native/app-version/ngx';
import { Device } from '@ionic-native/device/ngx';
import { GeolocationService } from 'src/providers/geolocation-service/geolocation-service';
import { Geolocation } from '@ionic-native/geolocation/ngx';
import { FiletransferService } from 'src/providers/filetransfer-service/filetransfer-service';
import { FileTransfer } from '@ionic-native/file-transfer/ngx';
import { Custom_RequestMethod } from 'src/providers/common-service';
import { PlayerPerformanceService } from 'src/providers/playerPerformance-service/playerPerformance-service';
import { ScorecardService } from 'src/providers/scorecard-service/scorecard-service';
import { EventLogService } from 'src/providers/eventlog-service/eventlog-service';
import '../../node_modules/chart.js/dist/Chart.bundle.js';
import '../../node_modules/chartjs-color-string/color-string.js';
import '../../node_modules/chartjs-color/index.js';
import { ScorecardStorageService } from 'src/providers/scorecard-service/scorecard-storage-service';
import {
  PlayerHomeActions,
  PlayerHomeDataService,
  PlayerHomeEffects,
} from 'src/redux/player-home';
import { Drivers } from '@ionic/storage';
import {
  CurrentScorecardEffects,
} from 'src/redux/scorecard';
import { DatePicker } from '@ionic-native/date-picker/ngx';
import { localStorageSync } from 'src/redux/storage-sync';
import { AppSync } from 'src/redux/appstate';
import { RootReducer } from 'src/redux/root-reducer';
import { ReduxProviders } from '../redux/redux-providers';
import { ServerInfoService } from 'src/providers/serverinfo-service/serverinfo-service';
import { ImageService } from 'src/providers/image-service/image-service';
import { MYGOLF_PROVIDERS } from 'src/providers';
import { NativeProviders } from 'src/native-plugin-providers';
import { EffectsModule } from '@ngrx/effects';
import { WebsocketEffects } from 'src/redux/wstomp';
import { NgCalendarModule } from 'ionic2-calendar';
import { PLAYER_MODULE_PAGES, MODAL_PAGES } from '../player-module-pages';
// import { PLAYER_MODULE_PIPES } from './../player-module-pipes';
import { TranslateModule, TranslateLoader, TranslateService, TranslateCompiler, TranslateParser, MissingTranslationHandler } from "@ngx-translate/core";
import { HttpClient } from "@angular/common/http";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { ManUpModule, ManUpService, TRANSLATE_SERVICE } from 'ionic-manup';
import { RecentClubPage } from './pages/performance/recent-club/recent-club.page';
import { PushNotificationEffects } from 'src/redux/pushnotf';
import { AdvertisementComponent } from 'src/custom/advertisement-component';
import { AdhandlerComponent } from 'src/custom/adhandler-component';
import { mygolfUtils } from '../custom/mygolf2u-utils';
import { DateRangePicker } from './shared/date-range-picker.component';
import { CalendarModule } from 'ion2-calendar';
import { FormsModule } from '@angular/forms';
import { LocationStrategy } from '@angular/common';
import { DatePipe } from '@angular/common';
// import { LottieModule } from 'ngx-lottie';
// import player from 'lottie-web';


export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http, "../assets/i18n/", ".json");
}

const prodReducer = compose(localStorageSync({
  keys: AppSync,
  prefix: 'mygolf2uapp',
  rehydrate: true
}),
  combineReducers)(RootReducer);
export function appReducer(state: any = {}, action: any) {

  return prodReducer(state, action);
}

@Injectable()
export class MyHammerConfig extends HammerGestureConfig {
  overrides = <any>{
    'swipe': { direction: 6 },
    'pinch': { enable: false },
    'rotate': { enable: false }
  }
}

// export function playerFactory() {
//   return player;
// }

@NgModule({
  declarations: [
    MyApp,
    AdvertisementComponent,
    AdhandlerComponent,
    DateRangePicker
    // ...PLAYER_MODULE_PIPES,
    // ...PLAYER_MODULE_PAGES
  ],
  imports: [
    HttpModule,
    BrowserModule,
    IonicModule.forRoot({
      _forceStatusbarPadding: true,
      scrollAssist: false,
      inputBlurring: false,
      scrollPadding: false,
      swipeBackEnabled: false,
    }),
    AppRoutingModule,
    HttpClientModule,
    // StoreModule.forRoot({ reducers: appReducer }),
    StoreModule.forRoot({ reducers: appReducer }, {
      runtimeChecks: {
        "strictStateImmutability": false,
        "strictActionImmutability": false,
        // "strictStateSerializability": true,
        // "strictActionSerializability": true,
      }
    }),
    // IonicModule.forRoot(MyApp,{PLAYER_MODULE_PAGES}),
    IonicStorageModule.forRoot({
      name: 'myname',
      driverOrder: [Drivers.IndexedDB], // , Drivers.LocalStorage
    }),

    EffectsModule.forRoot([PushNotificationEffects, DeviceActionEffects, SessionEffects, PlayerHomeEffects, WebsocketEffects, CurrentScorecardEffects]),
    NgCalendarModule,
    RecaptchaModule,
    RecaptchaFormsModule,
    CalendarModule.forRoot(),
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient]
      }
    }),
    // LottieModule.forRoot({ player: playerFactory()}),
    // TranslateModule.forChild({
    //   loader: {provide: TranslateLoader, useClass: null},
    //   compiler: {provide: TranslateCompiler, useClass: null},
    //   parser: {provide: TranslateParser, useClass: null},
    //   missingTranslationHandler: {provide: MissingTranslationHandler, useClass: null},
    //   isolate: true
    // }),
    ...MODAL_PAGES
  ],
  providers: [
    DatePipe,
    Custom_RequestMethod,
    mygolfUtils,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    { provide: TRANSLATE_SERVICE, useClass: TranslateService },
    ...NativeProviders,
    ...MYGOLF_PROVIDERS,
    ...ReduxProviders,
    {
      provide: RECAPTCHA_SETTINGS,
      useValue: {
        siteKey: '6LcJQM0ZAAAAAGVMmPWu6tTK4JzCj_TvNXm4gOIy',
      } as RecaptchaSettings,
    },
    { provide: LocationStrategy, useClass: PathPreserveQueryLocationStrategy},
    {
      provide: HAMMER_GESTURE_CONFIG,
      useClass: MyHammerConfig
    }
  ],
  entryComponents: [
    // ...PLAYER_MODULE_PAGES
  ],
  bootstrap: [MyApp],
})
export class AppModule { }
